import { STATUS_COLOR } from 'components/shared/operation/constants';

export const SHOPPING_CART_STATUS = {
  Pending: {
    label: 'در انتظار',
    color: STATUS_COLOR.ACTIVE,
  },
  WaitForCheck: {
    label: 'منتظر تایید',
    color: STATUS_COLOR.WAITING,
  },
  Done: {
    label: 'تایید شد',
    color: STATUS_COLOR.SUCCESS,
  },
  InProsses: {
    label: 'درحال جمع آوری',
    color: STATUS_COLOR.ACTIVE,
  },
};
